import ACHEMED24h from '../../assets/img/hospital-_1_.svg'
import Report from '../../assets/img/relatorio.svg'
import moment from "moment";
import { cpf } from "../../utils/formats";
import IMG30Min from '../../assets/img/30-minutos 1.svg'
import IMG45Min from '../../assets/img/30-minutos 2.svg'
import IMG60Min from '../../assets/img/30-minutos 3.svg'
import Amei from '../../assets/img/face-grin-hearts-solid 1.svg'
import Gostei from '../../assets/img/face-smile-solid 1.svg'
import Regular from '../../assets/img/face-meh-solid 1.svg'
import Odiei from '../../assets/img/face-sad-cry-solid 1.svg'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
export default ({ index, elem, setSchedulingToPay }) => {
    const calcTotal = (value1, value2) => {
        return Number(value1) + Number(value2)
    }
    const renderIconBonus = (elem) => {
        var image = <></>
        if (elem.type == 2) {
            switch (elem.reference_value) {
                case 0:
                    image = IMG30Min
                    break;
                case 1:
                    image = IMG45Min
                    break;
                case 2:
                    image = IMG60Min
                    break;

                default:
                    break;
            }
        }
        if (elem.type == 1) {
            switch (elem.reference_value) {
                case 0:
                    image = Odiei
                    break;
                case 1:
                    image = Regular
                    break;
                case 2:
                    image = Gostei
                    break;
                case 3:
                    image = Amei
                    break;
                default:
                    break;
            }
        }
        return (<img src={image} style={{ width: 22, margin: ' 0px 3px' }} />)
    }

    const calcularDiferenca = (horario1, horario2) => {
        if (horario1 === null || horario2 === null) return "00:00:00"
        const date1 = new Date(`1970-01-01T${horario1}`);
        const date2 = new Date(`1970-01-01T${horario2}`);

        const diferencaMilissegundos = Math.abs(date2 - date1);

        const diferencaSegundosTotais = Math.floor(diferencaMilissegundos / 1000);

        const horas = Math.floor(diferencaSegundosTotais / 3600);
        const minutos = Math.floor((diferencaSegundosTotais % 3600) / 60);
        const segundos = diferencaSegundosTotais % 60;

        return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
    }
    const renderTooltip = (name) => (
        <Tooltip id="button-tooltip" >
            {name}
        </Tooltip>
    );
    return (
        <div key={index} className='col-12' style={{ padding: '0px 10px', cursor: 'pointer' }}>
            <div>
                <label htmlFor={'inputcheckbox' + index} style={{ position: 'relative', alignItems: 'center', background: '#555555', padding: 5, opacity: elem.receipt_path !== null && 1 }} className='card-list row'>
                    {
                        elem.agreement_image !== undefined && elem.agreement_image !== null && (
                            <OverlayTrigger
                                placement="auto"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip(elem.agreement_name)}
                            >
                                <img src={elem.agreement_image} style={{ width: 48, borderRadius: '50%', position: 'absolute', top: 5, right: -6 }} />
                            </OverlayTrigger>

                        )
                    }
                    {
                        elem.is_achemed24h !== undefined && elem.is_achemed24h === true && (
                            <img src={ACHEMED24h} style={{ width: 48, position: 'absolute', bottom: 5, right: -6 }} />
                        )
                    }
                    {
                        elem.receipt_path === null ? (<div style={{ margin: 'auto', alignItems: 'center' }} className='d-flex col-12 col-sm-1 flex-column'>
                            <input style={{ width: 12 }} onChange={() => {
                                if (elem.receipt_path !== null) return
                                setSchedulingToPay(prevState => {
                                    if (prevState.includes(elem)) {
                                        return prevState.filter(scheduling => scheduling !== elem);
                                    } else {
                                        return [...prevState, elem];
                                    }
                                });
                            }} id={'inputcheckbox' + index} className="form-checkbox" type="checkbox" />
                        </div>) :
                            (<div style={{ alignItems: 'center', margin: 'auto' }} className='d-flex col-12 col-sm-1 flex-column'>
                                <div onClick={() => {

                                    window.open(elem.receipt_path, "_blank")

                                }} className="card-list-button">
                                    <img style={{ width: '17px' }} alt="svg" src={Report} />
                                </div>
                            </div>)
                    }

                    <div className='d-flex col-12 col-sm-4 flex-column'>
                        <span style={{ color: 'white' }} className='card-list-title card-list-title-column'>paciente</span>
                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'>{elem.customer_name}</span>
                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'>{moment(elem.customer_birth_date).format('DD/MM/YYYY')} {elem.customer_age} anos</span>
                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'>{cpf(elem.customer_cpf)}</span>
                    </div>
                    <div className='d-flex col-12 col-sm-3 flex-column'>
                        <span style={{ color: 'white' }} className='card-list-title card-list-title-column'>agendamento</span>
                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'>{elem.professional_name}</span>

                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'>{moment(elem.date_scheduling).format('DD/MM/YYYY') + " " + elem.time_starting_booked}</span>
                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'>  {elem.time_starting === null ? "00:00:00" : elem.time_starting} à {elem.time_end === null ? "00:00:00" : elem.time_end}  ({calcularDiferenca(elem.time_starting, elem.time_end)})</span>
                    </div>
                    <div className='d-flex col-12 col-sm-4 flex-column'>
                        <span style={{ color: 'white' }} className='card-list-title card-list-title-column'>faturamento</span>

                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'> <span style={{ fontWeight: 400, fontSize: 15 }}>Valor de Referência:</span>  {Number(elem.original_payment_value).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        })}</span>
                        <span style={{ color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }} className='card-list-name-payment card-list-name-big-info'>


                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                {
                                    elem["Applied satisfaction bonuses"] && elem["Applied satisfaction bonuses"].length !== 0 && renderIconBonus(elem["Applied satisfaction bonuses"][0])
                                }

                                {Number(elem.satiscation_bonus_payment_value).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })}
                            </span>

                            +

                            <span style={{ display: 'flex', alignItems: 'center' }}>

                                {
                                    elem["Applied time bonuses"] !== undefined && elem["Applied time bonuses"].length !== 0 && (renderIconBonus(elem["Applied time bonuses"][0]))
                                }
                                {Number(elem.time_bonus_payment_value).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })}
                            </span>


                            = {calcTotal(elem.satiscation_bonus_payment_value, elem.time_bonus_payment_value).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })
                            }


                        </span>
                        <span style={{ color: 'white' }} className='card-list-name-payment card-list-name-big-info'>  <span style={{ fontWeight: 400, fontSize: 15 }}>Valor Total:</span> {Number(elem.final_payment_value).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        })}</span>
                    </div>


                </label>
            </div>
        </div>
    )
}